import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';

const isNativePlatform = () => {
  try { return window.Capacitor && window.Capacitor.isNativePlatform(); } catch { return false; }
};

const dots = () => (
  <svg width="18" height="8" viewBox="0 0 18 8" fill="none">
    <circle cx="2" cy="4" r="2" fill="#0B1A2E"/>
    <circle cx="9" cy="4" r="2" fill="#0B1A2E"/>
    <circle cx="16" cy="4" r="2" fill="#0B1A2E"/>
  </svg>
);

export default function Nav({ page, setPage }) {
  const { user, logout } = useAuth();
  const isNative = isNativePlatform();
  // Web: always show top nav. Native: show only when logged out (logged-in users use bottom tab bar)
  const showTopNav = !isNative || !user;

  // Add body class so pages get correct top padding when nav is visible
  useEffect(() => {
    if (showTopNav) {
      document.body.classList.add('has-nav');
    } else {
      document.body.classList.remove('has-nav');
    }
    return () => document.body.classList.remove('has-nav');
  }, [showTopNav]);

  return (
    <>
      {/* Top nav — always shown on web, hidden on native */}
      {showTopNav && (
        <nav className="nav">
          <div className="nav-inner">
            <div className="nav-logo" onClick={() => setPage('home')} style={{ cursor: 'pointer', userSelect: 'none' }}>
              <div className="nav-logo-icon">{dots()}</div>
              <span className="nav-logo-text">MY TAPPING SCRIPT</span>
            </div>

            {/* Desktop nav links */}
            <div className="nav-links">
              {user ? (
                <>
                  <button className={`nav-link ${page === 'home' ? 'active' : ''}`} onClick={() => setPage('home')}>Home</button>
                  <button className={`nav-link ${page === 'create' ? 'active' : ''}`} onClick={() => setPage('create')}>Create Script</button>
                  <button className={`nav-link ${page === 'library' ? 'active' : ''}`} onClick={() => setPage('library')}>Library</button>
                  <button className={`nav-link ${page === 'learn' ? 'active' : ''}`} onClick={() => setPage('learn')}>Learn EFT</button>
                  <button className={`nav-link ${page === 'profile' ? 'active' : ''}`} onClick={() => setPage('profile')}>Profile</button>
                </>
              ) : (
                <>
                  <button className="nav-link" onClick={() => setPage('learn')}>Learn EFT</button>
                  <button className="nav-link" onClick={() => setPage('login')}>Sign In</button>
                  <button className="nav-btn" onClick={() => setPage('create')}>Get Started Free</button>
                </>
              )}
            </div>

            {/* Mobile-only links for non-logged-in users */}
            {!user && (
              <div className="nav-mobile-links">
                <button className="nav-link" onClick={() => setPage('learn')}>Learn EFT</button>
                <button className="nav-link" onClick={() => setPage('login')}>Sign In</button>
              </div>
            )}
          </div>
        </nav>
      )}

      {/* Mobile tab bar */}
      {user && (
        <div className="tab-bar">
          <div className="tab-bar-inner">
            <button className={`tab-item ${page === 'home' ? 'active' : ''}`} onClick={() => setPage('home')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9,22 9,12 15,12 15,22"/></svg>
              Home
            </button>
            <button className={`tab-item ${page === 'create' ? 'active' : ''}`} onClick={() => setPage('create')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
              Create
            </button>
            <button className={`tab-item ${page === 'library' ? 'active' : ''}`} onClick={() => setPage('library')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>
              Library
            </button>
            <button className={`tab-item ${page === 'profile' ? 'active' : ''}`} onClick={() => setPage('profile')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              Profile
            </button>
          </div>
        </div>
      )}
    </>
  );
}
